import React from 'react'
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from '../../common/Pagination/Pagination';
import { Button } from '../../common/Button/Button';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

const ESPSubscibersGrid = (props) => {

    // const Data = [
    //     {
    //         "sFirstName": "John",
    //         "sLastName": "Doe",
    //         "sEmailAddress": "john.doe@example.com",
    //         "sContactNumber": "1234567890",
    //         "subsciptionStartDate": "01-01-2024",
    //         "subscriptionEndDate": "01-01-2025",
    //         "oppourtunitiesAvailed": [
    //             {
    //                 "ResourceDisplayName": "Web Development Course",
    //                 "status": "Approved"
    //             }
    //         ],
    //         "resourceAvailed": [
    //             {
    //                 "ResourceDisplayName": "Python Programming Course",
    //                 "status": "Eligible"
    //             }
    //         ],
    //         "oppourtunitiesRemaining": 0
    //     },
    //     {
    //         "sFirstName": "Jane",
    //         "sLastName": "Smith",
    //         "sEmailAddress": "jane.smith@example.com",
    //         "sContactNumber": "9876543210",
    //         "subsciptionStartDate": "02-02-2024",
    //         "subscriptionEndDate": "02-02-2025",
    //         "oppourtunitiesAvailed": [
    //             {
    //                 "ResourceDisplayName": "Data Science Workshop",
    //                 "status": "Requested"
    //             }
    //         ],
    //         "resourceAvailed": [
    //             {
    //                 "ResourceDisplayName": "Machine Learning Course",
    //                 "status": "Approved"
    //             }
    //         ],
    //         "oppourtunitiesRemaining": 2
    //     },
    //     {
    //         "sFirstName": "Alice",
    //         "sLastName": "Johnson",
    //         "sEmailAddress": "alice.johnson@example.com",
    //         "sContactNumber": "5555555555",
    //         "subsciptionStartDate": "03-03-2024",
    //         "subscriptionEndDate": "03-03-2025",
    //         "oppourtunitiesAvailed": [
    //             {
    //                 "ResourceDisplayName": "Digital Marketing Seminar",
    //                 "status": "Approved"
    //             }
    //         ],
    //         "resourceAvailed": [
    //             {
    //                 "ResourceDisplayName": "SEO Training",
    //                 "status": "Eligible"
    //             }
    //         ],
    //         "oppourtunitiesRemaining": 2
    //     },
    //     {
    //         "sFirstName": "Michael",
    //         "sLastName": "Brown",
    //         "sEmailAddress": "michael.brown@example.com",
    //         "sContactNumber": "1112223333",
    //         "subsciptionStartDate": "04-04-2024",
    //         "subscriptionEndDate": "04-04-2025",
    //         "oppourtunitiesAvailed": [
    //             {
    //                 "ResourceDisplayName": "Leadership Workshop",
    //                 "status": "Requested"
    //             }
    //         ],
    //         "resourceAvailed": [
    //             {
    //                 "ResourceDisplayName": "Project Management Course",
    //                 "status": "Approved"
    //             }
    //         ],
    //         "oppourtunitiesRemaining": 2
    //     },
    //     {
    //         "sFirstName": "Emily",
    //         "sLastName": "Davis",
    //         "sEmailAddress": "emily.davis@example.com",
    //         "sContactNumber": "9998887777",
    //         "subsciptionStartDate": "05-05-2024",
    //         "subscriptionEndDate": "05-05-2025",
    //         "oppourtunitiesAvailed": [
    //             {
    //                 "ResourceDisplayName": "Public Speaking Workshop",
    //                 "status": "Approved"
    //             }
    //         ],
    //         "resourceAvailed": [
    //             {
    //                 "ResourceDisplayName": "Presentation Skills Training",
    //                 "status": "Eligible"
    //             }
    //         ],
    //         "oppourtunitiesRemaining": 2
    //     }
    // ]

    const data = {
        "services": [
            {
                "nUserId": 128,
                "nResourceInstanceId": 223425,
                "sServiceDisplayName": "deAsra PRIME",
                "sFirstName": "Balaji",
                "sLastName": "Kawhale",
                "sEmailAddress": "balaji@conveniotech.com",
                "sContactNumber": "9999999999",
                "sServiceCode": "DEASRASUBSMODEL",
                "sCatalogueId": "DEASRASUBSMODEL_1_Step_Payment_Offline_deAsra",
                "subscription_start_date": "2024-03-06T08:32:25.931865Z",
                "subscription_end_date": "2025-03-06T08:32:25.931865Z",
                "Opportunities": 3,
                "Remaining_Opportunities": 0,
                "service_count": 3
            },
            {
                "nUserId": 197,
                "nResourceInstanceId": 223425,
                "sServiceDisplayName": "deAsra PRIME",
                "sFirstName": "Manisha",
                "sLastName": "Lahade",
                "sEmailAddress": "manisha@conveniotech.com",
                "sContactNumber": "7020967361",
                "sServiceCode": "DEASRASUBSMODEL",
                "sCatalogueId": "DEASRASUBSMODEL_1_Step_Payment_Offline_deAsra",
                "subscription_start_date": "2024-03-06T08:32:25.931865Z",
                "subscription_end_date": "2025-03-06T08:32:25.931865Z",
                "Opportunities": 3,
                "Remaining_Opportunities": 0,
                "service_count": 2
            }
        ]
    }
    
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-IN', options);
      };

    const columns = [
        {
            id: 'sEmailAddress',
            Header: 'Subscribers Details',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            // accessor: "sEmailAddress",
            width:310,
            Cell: ({ original }) => (
				<>
					<div className={"conv-float-left"}>
                    
										<div>
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Name:</span>
											{
												original.sFirstName && original.sLastName ?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
                                                        {
                                                            `${original.sFirstName &&
                                                                original.sFirstName 
                                                            }${' '}
                                                            ${original.sLastName &&
                                                                original.sLastName 
                                                            }`
                                                        }
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
                                        <div style={{"clear":"both"}}></div>
										<div  className="conv-mt10">
											<span className="conv-float-left conv-mr18 lpm-service-grid-key">Email:</span>
											{
												original.sEmailAddress?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all"}}>
															
															{
																original.sEmailAddress
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Contact:</span>
											{
												original.sContactNumber?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{
																original.sContactNumber
															}
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
									</div>
				</>
			),
        },
        {
            id: 'subscription_start_date',
            Header: 'Subscription Start Date',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "subscription_start_date",
            // width:130,
            Cell: ({ value }) => formatDate(value),
        },
        {
            id: 'subscription_end_date',
            Header: 'Subscription End Date',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "subscription_end_date",
            Cell: ({ value }) => formatDate(value),
        },
        {
            id: 'Opportunities',
            Header: 'Oppourtunities Availed',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "Opportunities",
            // width:130,
            Cell: ({ original }) => (
                <>
                    <span onClick={() => props.oppourtunitiesAvailedCountClick(original.nUserId)}>{original.Opportunities_Awailed}</span>
                </>
            )
        },
        {
            id: 'Remaining_Opportunities',
            Header: 'Oppourtunities Remaining',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "Remaining_Opportunities",
            // width:130,
            // Cell: ({ value }) => (value ? 'Yes' : 'No')
            Cell: ({ original }) => (
                <>
                    <span>{original.Opportunities - original.Opportunities_Awailed}</span>
                </>
            )
        },
        {
            id: 'service_count',
            Header: 'Resource Availed',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "service_count",
            // width:130,
            Cell: ({ original }) => (
                <>
                    <span onClick={() => props.resourceAvailedCountClick(original.nUserId)}>{original.service_count}</span>
                </>
            )
        },
        {
            Header: 'Action',
            id: 'action',
            Cell: ({ original }) => (
                <>
                    {
                    original.Opportunities - original.Opportunities_Awailed != 0 ?
                                    <button className="my-services-model-submit-btn"
                //  onClick={() => props.onOpenBtnClick(original.nParentId)}
                 >Send Notification</button>
                 :
                 <button style={{pointerEvents: 'none', opacity: 0.4}}
                 className="my-services-model-submit-btn"
                //  onClick={() => props.onOpenBtnClick(original.nParentId)}
                 >Send Notification</button>
                }
                </>
            ),
            width: 200
        }
    ]


    

  return (
    <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">

        <div className="spled-container">
            <div className="service-partner spled-container">
            <ReactTableFixedColumns
						minRows={0}
						data={props.data || []}
						columns={columns}
						manual
						defaultPage={props.page}
						pages={props.pages}
						page={props.page}
						pageSize={props.pageSize}
						sortable={false}
						defaultPageSize={10}
						showPagination={true}
						pageSizeOptions={[10,20,30,50,75,100]}
						onFetchData={(state, instance) => {
							props.onFetchServiceRequests(instance, false);
						}}
						onPageSizeChange={props.onPageSizeOptionChange}
						PaginationComponent={Pagination}
						style={{overflowY: "initial",height: "390px"}}			
						className="-striped hide-scrollbar"
					/>
            </div>
        </div>
    </div>
  )
}

export default ESPSubscibersGrid
